module.exports = __webpack_public_path__ + "static/italianRestaurant-199c1060b1e6c2915e67824d95f2cc6e.png";